var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcIdActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5c0-2.761 2.239-5 5-5h20c2.761 0 5 2.239 5 5v20c0 2.761-2.239 5-5 5h-20c-2.761 0-5-2.239-5-5v-20Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.757 8.753h4.907c3.909 0 5.649 2.344 5.649 6.198c0 3.891-1.785 6.299-5.649 6.299h-4.907v-12.497Zm3.03 2.399v7.699h1.401c1.749 0 3.021-0.741 3.021-3.827c0-2.197-0.677-3.872-3.021-3.872h-1.401Z",
    fill: "#EB2553"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.331 21.25h-3.031v-12.497h3.031v12.497Z",
    fill: "#EB2553"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIdActive);
export default __webpack_public_path__ + "static/media/ic_id_active.e4fc7bc3bd807dd15bf561a3b3f14d4f.svg";
export { ForwardRef as ReactComponent };